export const projects = [
  {
    id: 1,
    title: 'DND Homes',
    category: 'residential',
    location: 'Greater Boston Area, MA',
    scale: 'Multi-million dollar homes',
    date: '2024',
    description:
      "Electrical design and installation for luxury high-end homes across Boston's most prestigious communities — Lexington, Newton, Brookline, and Cambridge. Homes range from $1.26M to $4.79M.",
    features: ['Smart home integration', 'LED lighting design', 'Solar systems', 'EV charging'],
    /*
      VISUAL DIRECTION v1.1
      ✅ Use: Documentary-style commercial jobsite photography. Architectural project photography.
             Real crews on active sites. Equipment, conduit runs, panel gear, aerial shots.
             Style reference: ENR contractor editorial. No staged scenes.
      ❌ Avoid: Stock models smiling at camera. AI-generated workers. Cinematic color grading.
                Fake or overly polished jobsite scenes. Hero images that look like insurance ads.
    */
    image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=450&fit=crop&q=80',
    link: 'https://dnd-homes.com/',
  },
  {
    id: 2,
    title: 'Eastland Partners — Mixed-Use Center',
    category: 'mixed-use',
    location: '217 West Central St, Natick, MA',
    scale: '4,500+ sq ft retail suites',
    date: '2024',
    description:
      'Full electrical systems for a high-traffic mixed-use retail center with national tenants including Planet Fitness and NTB. Serves 1,400+ daily customers with 235+ parking spaces on a 22,000 daily-traffic corridor.',
    features: ['Retail lighting', 'Power distribution', 'Parking lot lighting', 'Energy management'],
    /*
      VISUAL DIRECTION v1.1
      ✅ Use: Documentary-style commercial jobsite photography. Architectural project photography.
             Real crews on active sites. Equipment, conduit runs, panel gear, aerial shots.
             Style reference: ENR contractor editorial. No staged scenes.
      ❌ Avoid: Stock models smiling at camera. AI-generated workers. Cinematic color grading.
                Fake or overly polished jobsite scenes. Hero images that look like insurance ads.
    */
    image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&h=450&fit=crop&q=80',
    link: 'https://eastlandpartners.com/commercial/',
  },
  {
    id: 3,
    title: 'Natick Corner Apartments',
    category: 'residential',
    location: '69 E Central St, Natick, MA',
    scale: '1–2 bed units, $2,700–$4,300/mo',
    date: '2025',
    description:
      'Brand-new luxury apartment complex in downtown Natick. Modern construction with in-unit washer/dryer, stainless steel appliances, balconies, elevator access, and walkable MBTA access.',
    features: ['In-unit electrical', 'EV charging stations', 'Common area lighting', 'Main panel install'],
    /*
      VISUAL DIRECTION v1.1
      ✅ Use: Documentary-style commercial jobsite photography. Architectural project photography.
             Real crews on active sites. Equipment, conduit runs, panel gear, aerial shots.
             Style reference: ENR contractor editorial. No staged scenes.
      ❌ Avoid: Stock models smiling at camera. AI-generated workers. Cinematic color grading.
                Fake or overly polished jobsite scenes. Hero images that look like insurance ads.
    */
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&h=450&fit=crop&q=80',
    link: 'https://www.apartments.com/natick-corner-natick-ma/hcgycv2/',
  },
  {
    id: 4,
    title: 'Bolton Square Office Park',
    category: 'commercial',
    location: '580 Main St, Bolton, MA',
    scale: '105,600 sq ft on 36 acres',
    date: '2024',
    description:
      'Complete electrical infrastructure for a two-story Class-A office and flex building in Bolton Office Park. Features a marble atrium lobby, two interior courtyards, and full power distribution across lab, office, and storage suites.',
    features: ['Power distribution', 'Building automation', 'Emergency systems', 'Lighting design'],
    /*
      VISUAL DIRECTION v1.1
      ✅ Use: Documentary-style commercial jobsite photography. Architectural project photography.
             Real crews on active sites. Equipment, conduit runs, panel gear, aerial shots.
             Style reference: ENR contractor editorial. No staged scenes.
      ❌ Avoid: Stock models smiling at camera. AI-generated workers. Cinematic color grading.
                Fake or overly polished jobsite scenes. Hero images that look like insurance ads.
    */
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=450&fit=crop&q=80',
    link: 'https://www.loopnet.com/Listing/580-Main-St-Bolton-MA/37472520/',
  },
];
